import React, { useState } from 'react';
import Modal from '../components/Modal/Modal';
import AddEntity from '../components/AddEntity/AddEntity';
import ApiManager from '../ApiManager/ApiManager';

const LabelFields = [
    { label: 'Type', name: 'name', type: 'text', required: true},
    { label: 'Percentage (%)', name: 'percentage', type: 'number', step: '0.01', required: true }
];



const NewTax = ({onSuccess}) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
    };

    return (
        <div>
                <button className="custom-button" onClick={toggleModal}>
                    New Tax
                </button>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <AddEntity
                    toggleFunction={toggleModal}
                    title="Add Tax"
                    formFields={LabelFields}
                    apiFunction={ApiManager.addTaxType}
                    onSuccess={onSuccess}
                />
            </Modal>
        </div>
    );
};

export default NewTax;
